export class CountryMapZoom {
    countryMap!: ICountryMap[];
    regionCountryCode!: string;
}
export interface ICountryMap {
    countryName: string;
    countryCode: string;
    countryValue: number;
    text: string;
    colour: string;
}

